<script setup>
import { ref } from "vue";
import api from "@/api";
import cookie from "js-cookie";
import vSelect from "vue-select";

const props = defineProps({
  defaultLangSegment: {
    type: String,
    required: false,
    default: () => {},
  },
});

const emits = defineEmits(["change"]);

const selectedLang = ref("");
const langs = ref([
  {
    id: "en",
    name: "English",
    icon: "/welcome/langs/en.svg",
  },
  {
    id: "ar",
    name: "عربي",
    icon: "/welcome/langs/ar.svg",
  },
  {
    id: "id",
    name: "Indonesian",
    icon: "/welcome/langs/id.svg",
  },
  {
    id: "tr",
    name: "Turkish",
    icon: "/welcome/langs/tr.svg",
  },
  {
    id: "it",
    name: "Italian",
    icon: "/welcome/langs/it.svg",
  },
  {
    id: "pl",
    name: "Polish",
    icon: "/welcome/langs/pl.svg",
  },
  {
    id: "es",
    name: "Spanish",
    icon: "/welcome/langs/es.svg",
  },
  {
    id: "pt",
    name: "Portuguese",
    icon: "/welcome/langs/pt.svg",
  },
  {
    id: "ms",
    name: "Malaysian",
    icon: "/welcome/langs/my.svg",
  },
]);

const changeLang = (item) => {
  emits("change", item.id);
  cookie.set("autobookingLang", item.id);
};

const loadLangs = () => {
  const ruLang = {
    id: "ru",
    name: "Russian",
    icon: "/welcome/langs/ru.svg",
  };

  const langFromCookie = cookie.get("autobookingLang");

  if (props.defaultLangSegment === "ru" || langFromCookie === "ru") {
    langs.value.unshift(ruLang);
  }

  let lang = langFromCookie || props.defaultLangSegment || "en";

  selectedLang.value = langs.value.find((el) => el.id === lang);
  if (!selectedLang.value) {
    selectedLang.value = {
      id: "en",
      name: "English",
      icon: "/welcome/langs/en.svg",
    };
  }
};

loadLangs();
</script>

<template>
  <div>
    <v-select
      v-model="selectedLang"
      :options="langs"
      :clearable="false"
      :searchable="false"
      label="name"
      class="select select-lang"
      @option:selected="changeLang">
      <template #selected-option="{ icon }">
        <div class="select-container">
          <div class="select-content">
            <img class="select__icon" :src="icon" />
          </div>
        </div>
      </template>
      <template #option="{ icon, name }">
        <div class="select-option">
          <img class="select-option__icon" :src="icon" />
          <span class="select-option__name">{{ name }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<style lang="scss" scoped>
.select {
  &__icon {
    width: 32px;
    border: 1px solid #5988ff;
    border-radius: 50%;
  }
}
</style>
